import { CommonModule } from '@angular/common';
import { Component, signal } from '@angular/core';
import { RouterModule } from '@angular/router';
import { MenuItem } from 'primeng/api';
import { ShellHeaderComponent } from '../content/shell-header/shell-header.component';
import { ShellSidebarComponent } from '../sidebar/shell-sidebar/shell-sidebar.component';
import { FooterComponent } from '../content/footer/footer.component';
import { MenuService } from '../../core/services/menu.service';
import { BreadcrumbComponent } from '../../shared/components/breadcrumb/breadcrumb.component';


@Component({
  selector: 'app-shell',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    ShellHeaderComponent,
    ShellSidebarComponent,
    BreadcrumbComponent,
    FooterComponent
  ],
  templateUrl: './shell.component.html'
})
export class ShellComponent {
  collapsed = true;
  items: MenuItem[] = [];
  private readonly openMapSignal = signal<Record<string, boolean>>({});

  constructor(private readonly menuService: MenuService) {
    this.items = this.menuService.items();
  }

  open(): Record<string, boolean> {
    return this.openMapSignal();
  }

  toggle(): void {
    this.collapsed = !this.collapsed;
  }

  toggleSection(id: string): void {
    const atual = this.openMapSignal();

    this.openMapSignal.set({
      ...atual,
      [id]: !atual[id]
    });
  }
}